module.exports = __webpack_public_path__ + "static/media/folder-upload.3fe2cd66.svg";